<img src="../../../../../../../assets/icons/question.png" class="pointer float-right" alt="" height="25" (click)="onAyuda()"
    [ngClass]="class" />